<template>
  <app-page>
    <dx-data-grid
      :columns="columns"
      :data-source="dataSource"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      :column-auto-width="true"
      :hover-state-enabled="!gridTouch"
      :allow-column-reordering="!gridTouch"
      :allow-column-resizing="!gridTouch"
      :scrolling="scrolling"
      :element-attr="gridAttr"
    >
      <dx-editing
        refresh-mode="full"
        :allow-adding="false"
        :allow-updating="false"
        :allow-deleting="false"
        mode="batch"
      />

      <dx-pager
        :show-page-size-selector="true"
        :allowed-page-sizes="pageSizes"
        :show-info="true"
        :visible="true"
        :info-text="'Seite {0} von {1} ({2} Tarifversionen)'"
      />
      <dx-filter-row :visible="true" />
      <dx-paging :page-size="defaultPageSize" />
    </dx-data-grid>
  </app-page>
</template>

<script>
import {
  DxDataGrid,
  DxPaging,
  DxPager,
  DxFilterRow,
  DxEditing,
} from "devextreme-vue/data-grid";
import DataGridMixin from "@/mixins/DataGridMixin";
import CustomStore from "devextreme/data/custom_store";
import axios from "axios";

export default {
  components: {
    DxDataGrid,
    DxPager,
    DxFilterRow,
    DxPaging,
    DxEditing,
  },
  mixins: [DataGridMixin],
  data() {
    return {
      gridAttr: {},
      columns: [
        {
          dataField: "tariff_version_id",
          caption: "Tarifversion ID",
        },
        {
          dataField: "tariff_zone_id",
          caption: "Tarifzonen ID",
        },
        {
          dataField: "valid_from",
          caption: "gültig ab",
          dataType: "date",
        },
      ],
      dataSource: new CustomStore({
        key: ["tariff_version_id"],
        load: () => axios.get(`${this.$store.state.baseUrl}tariffversion`),
      }),
    };
  },
};
</script>

<style scoped>
</style>
